var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFileFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 78.885,
    viewBox: "0 0 84 78.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34017",
    "data-name": "Group 34017",
    transform: "translate(116.234 -35.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72232",
    "data-name": "Path 72232",
    d: "M-110.054,94.287h2.926L-109.1,98.3h-2.4a4.714,4.714,0,0,1-4.734-4.734V47.378a4.763,4.763,0,0,1,4.734-4.767h4.339v4.043h-2.893a2.161,2.161,0,0,0-2.17,2.137V92.118A2.189,2.189,0,0,0-110.054,94.287Z",
    transform: "translate(0 16.135)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72233",
    "data-name": "Path 72233",
    d: "M-93.471,49.716v7.068h-4.043l.033-11.473A4.427,4.427,0,0,1-93.471,49.716Z",
    transform: "translate(42.818 22.31)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72234",
    "data-name": "Path 72234",
    d: "M-66.242,47.063-76.3,36.116a1.788,1.788,0,0,0-1.315-.559h-31.1a3.863,3.863,0,0,0-3.879,3.879s-.132,42.5,0,56.673c0,1.414.756,1.479.756,1.479l2.5-5.066V39.436a.622.622,0,0,1,.625-.625h28.731a.807.807,0,0,1,.789.822v8.646a1.666,1.666,0,0,0,1.644,1.611h7.692a.814.814,0,0,1,.822.822V76.583h3.254v-28.3A1.8,1.8,0,0,0-66.242,47.063Zm-9.665-.427V41.372l4.832,5.263Z",
    transform: "translate(8.194 0)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72235",
    "data-name": "Path 72235",
    d: "M-78.629,40.931H-108.7a2,2,0,0,0-1.992,2.025,2.007,2.007,0,0,0,1.992,1.989h30.069A2.008,2.008,0,0,0-76.6,42.953,2.006,2.006,0,0,0-78.6,40.931Z",
    transform: "translate(12.681 12.292)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72236",
    "data-name": "Path 72236",
    d: "M-76.609,46.493a2.01,2.01,0,0,0-2.009-2.005h-30.069a2.006,2.006,0,0,0-2.009,2.005,2.008,2.008,0,0,0,2.009,2.009h30.069A2.013,2.013,0,0,0-76.609,46.493Z",
    transform: "translate(12.669 20.428)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72237",
    "data-name": "Path 72237",
    d: "M-42.039,52.744-56.175,79.7a.937.937,0,0,1-.835.506h-50.7L-94.389,53.27a.94.94,0,0,1,.848-.526h51.5m2.262-3.945H-93.541a4.888,4.888,0,0,0-4.382,2.722l-16.141,32.633h57.055a4.889,4.889,0,0,0,4.329-2.62L-37.5,52.573A2.577,2.577,0,0,0-39.777,48.8Z",
    transform: "translate(4.963 30.289)",
    fill: "#263757"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34016",
    "data-name": "Group 34016",
    transform: "translate(-77.16 88.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34014",
    "data-name": "Group 34014",
    transform: "translate(3.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72238",
    "data-name": "Path 72238",
    d: "M-102.293,68.788c-.874,0-1.233-.71-.8-1.588l7.005-14.06a2.966,2.966,0,0,1,2.377-1.584c.874,0,1.233.707.8,1.584l-7,14.06A2.98,2.98,0,0,1-102.293,68.788Z",
    transform: "translate(103.275 -51.556)",
    fill: "#263757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34015",
    "data-name": "Group 34015",
    transform: "translate(0 7.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72239",
    "data-name": "Path 72239",
    d: "M-89.306,56.866h-14.057c-.878,0-1.236-.71-.8-1.584a2.979,2.979,0,0,1,2.377-1.588h14.06c.874,0,1.233.71.8,1.588A2.978,2.978,0,0,1-89.306,56.866Z",
    transform: "translate(104.348 -53.694)",
    fill: "#263757"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileFolder);
export default __webpack_public_path__ + "static/media/add-file-folder.55bd23dde8f404e8aba880e66273b3d6.svg";
export { ForwardRef as ReactComponent };